import Input from "./Input"
import { useState, useEffect } from "react"
import { ITextFieldProperties } from "../fields"
import { CommonErrorText } from "../../../common/errorText"
import { ChangeType } from "../../../api/EventTypes"

const TextField = (props: ITextFieldProperties) => {
  const { required } = props

  const [error, setError] = useState(false)
  const [tooltip, setTooltip] = useState(false)

  useEffect(() => {
    const hasError = props.touched && props.isEmpty
    const validated = props.validator && props.validator.test(props.value)

    if (
      props.value !== "" &&
      props.value !== null &&
      !validated &&
      props.touched
    ) {
      setError(true)
      setTooltip(true)
    }

    if (!validated && props.touched) {
      if (required) {
        setError(true)
        setTooltip(true)
      }
    }

    if (hasError && props.touched) {
      setError(true)
      setTooltip(true)
    }

    if (props.clearErrors === false) {
      setError(false)
      setTooltip(false)
    }
  }, [
    props.clearErrors,
    props.isEmpty,
    props.touched,
    props.validator,
    props.value,
    required
  ])

  const handleValueChange = (e: ChangeType) => {
    const { name, value } = e.target
    const empty = value === ""
    setTooltip(false)
    const validated = props.validator && props.validator.test(value.trim())
    const errors =
      validated !== undefined &&
      ((required && !validated) || (!empty && !validated))

    if (!empty) {
      if (validated) {
        setError(false)
      }
    }
    if (empty && !required) {
      setError(false)
    }
    if (validated === undefined) {
      setError(false)
    }
    if (!validated) {
      if (required) {
        setError(true)
      }
      if (value !== "" && validated !== undefined) {
        setError(true)
      }
    }

    props.onChange(name, value, errors)
  }

  const handleBlur = (e: ChangeType) => {
    const { value } = e.target
    const validated = props.validator && props.validator.test(value)
    setTooltip(true)
    if (validated === undefined) {
      setError(false)
    }

    if (!validated) {
      if (required) {
        setError(true)
      }
      if ((value !== "" && validated !== undefined) || props.hasError) {
        setError(true)
      }
    }
  }

  const errorText = props.isEmpty
    ? CommonErrorText.noEmptyValue
    : props?.validationError

  const showTooltip = error && tooltip

  return (
    <Input
      name={props?.name}
      inputIdentifier={props?.name}
      label={props?.caption}
      value={props.value}
      onChange={handleValueChange}
      onBlur={handleBlur}
      hasChanges={props?.hasChanges}
      uppercase={props?.uppercase}
      maxLength={props?.maxLength}
      readonly={props?.readonly}
      labelOnBorder={props?.labelOnBorder}
      error={errorText}
      hideErrorMsg
      showTooltip={showTooltip}
      placeholder={props.placeholder}
      onKeyUp={(e) => {
        if (props.uppercase) {
          props.onChange(
            props.name,
            (e.target as HTMLInputElement).value.toUpperCase(),
            error
          )
        }
      }}
    />
  )
}

export default TextField
